export const periods = ['Квартал', 'Предыдущий год', 'Весь период работы']

export default {
  namespaced: true,
  state: {
    period: periods[0]
  },
  mutations: {
    setPeriod (state, period) {
      state.period = period
    }
  }
}
